import React from "react";

type Props = {
  mainProgramName: string;
};

export default function MainProgramName({ mainProgramName }: Props) {
  return <h3 className="main-program-name mb-md-2 mb-1">{mainProgramName}</h3>;
}
